<div class="main-container" *ngIf="!isLoading; else loading">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="d-grid gap-32">
        <div class="prospect-card">
          <div class="prospect-header">
            <div class="d-flex align-center gap-10">
              <img src="assets/svg/task-icon-orange.svg" alt="icono tarea" />
              <h2 class="text-semibold t-24">{{ tarea?.titulo || 'Sin título' }}</h2>
            </div>

            <div class="header-right-section">
              <div class="d-flex align-center gap-16 flex-wrap justify-end">
                <button class="action-btn primary" *ngIf="tarea?.estado !== 'Completada'">
                  Marcar completada
                </button>
                <button *ngIf="permissionService.hasPermission('Tareas y recordatorios','Eliminar')" class="action-btn outline delete-btn" (click)="openmdldeleteTask(tarea)">
                  Eliminar
                </button>
                <button *ngIf="permissionService.hasPermission('Tareas y recordatorios','Eliminar')" class="action-btn outline" (click)="openmdlmodifyTask(tarea)">
                  Modificar
                </button>
                
                <div class="dropdown-container" (click)="$event.stopPropagation()">
                  <button class="btn btn-round-outline" (click)="toggleActionsMenu('menu-'+ tarea.tarea_id)">
                    <img src="assets/svg/tridots.svg" class="center-svg" />
                  </button>
                  <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-'+ tarea.tarea_id">
                    <button class="dropdown-item">Cambiar fecha</button>
                    <button *ngIf="permissionService.hasPermission('Tareas y recordatorios','Cambiar etapa')" class="dropdown-item" (click)="openmdlchangeStatus(tarea)">Cambiar estado</button>
                    <button *ngIf="permissionService.hasPermission('Tareas y recordatorios','Editar')" class="dropdown-item" (click)="openmdlchangePriority(tarea)">Cambiar prioridad</button>
                  </div>
                </div>
              </div>

              <div class="d-flex align-center gap-10 mt-3 justify-end">
                <span class="text-regular t-16">Estado tarea:</span>
                <span class="estado-badge" 
                      [ngClass]="{
                        'status-completada': tarea?.estado === 'Completada',
                        'status-incompleta': tarea?.estado === 'Incompleta',
                        'status-pendiente': tarea?.estado === 'Pendiente',
                        'status-enprogreso': tarea?.estado === 'En progreso',
                        'status-vencida': tarea?.estado === 'Vencida'
                      }">
                  {{ tarea?.estado || 'Sin estado' }}
                </span>
              </div>
            </div>
          </div>

          <div class="info-card mt-4">
            <div class="d-grid info-card-title">
              <h3>Información de la tarea</h3>
              <div class="d-grid card-buttons-1">
                <img src="assets/svg/edit.svg" />
                <button class="btn btn-round-outline-mini">
                  <img class="center-svg" src="assets/svg/arrow-up.svg" />
                </button>
              </div>
            </div>

            <div class="info-card-detail grid-2col">
              <div class="info-item">
                <span class="label">Título:</span>
                <span class="value">{{ tarea?.titulo }}</span>
              </div>

              <div class="info-item">
                <span class="label">Prioridad:</span>
                <span
                  class="value prioridad"
                  [ngClass]="{
                    'prioridad-alta': tarea.prioridad === 'Alta',
                    'prioridad-media': tarea.prioridad === 'Media',
                    'prioridad-baja': tarea.prioridad === 'Baja'
                  }"
                >
                  {{ tarea?.prioridad }}
                </span>
              </div>

              <div class="info-item">
                <span class="label">Relacionado con:</span>
                <span class="value color-org">
                  <ng-container [ngSwitch]="tarea.asociado_tipo">
                        <span
                          *ngSwitchCase="'CNT'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre + ' ' + tarea.asociado?.apellido"
                        >
                          <b>Contacto: </b>{{ tarea.asociado?.nombre }} {{
                          tarea.asociado?.apellido }}
                        </span>

                        <span
                          *ngSwitchCase="'ACC'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre_empresa"
                        >
                          <b>Cuenta:</b> {{ tarea.asociado?.nombre_empresa }}
                        </span>

                        <span
                          *ngSwitchCase="'OPP'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre"
                        >
                          <b>Oportunidad:</b> {{ tarea.asociado?.nombre }}
                        </span>

                        <span
                          *ngSwitchCase="'PRO'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre"
                        >
                          <b>Prospecto:</b> {{ tarea.asociado?.nombre }} {{ tarea.asociado?.apellido}}
                        </span>

                        <span *ngSwitchDefault class="color-gray">
                          {{ tarea.asociado_tipo === 'OTRO' ? 'Sin relación
                          específica' : tarea.asociado_tipo }}
                        </span>
                      </ng-container>
                </span>
              </div>

              <div class="info-item">
                <span class="label">Fecha de vencimiento:</span>
                <span class="value">
                  {{ tarea?.fecha_vencimiento | date: 'dd/MM/yyyy' }} {{
                  tarea?.hora_vencimiento }}
                </span>
              </div>

              <div class="info-item">
                <span class="label">Asignado a:</span>
                <span class="value d-flex align-center gap-8">
                  <img src="assets/svg/user-icon.svg" width="20" />
                  {{ tarea?.ejecutivo?.nombre }} {{ tarea?.ejecutivo?.apellido
                  }}
                </span>
              </div>

              <div class="info-item">
                <span class="label">Comentario:</span>
                <span class="value"
                  >{{ tarea?.comentarios || 'Sin comentarios' }}</span
                >
              </div>
            </div>
          </div>

          <div class="info-card mt-4">
            <div class="d-grid info-card-title">
              <h3>Otra información</h3>
              <div class="d-grid card-buttons-1">
                <img src="assets/svg/edit.svg" />
                <button class="btn btn-round-outline-mini">
                  <img class="center-svg" src="assets/svg/arrow-up.svg" />
                </button>
              </div>
            </div>
            <div class="info-card-detail grid-2col mt-2">
              <div class="info-item">
                <span class="label">Repetir esta tarea:</span>
                <input
                  type="checkbox"
                  [checked]="tarea?.repetir === 1"
                  disabled
                />
              </div>
              <div class="info-item">
                <span class="label">Recordatorio establecido:</span>
                <input
                  type="checkbox"
                  [checked]="tarea?.recordatorio === 1"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="info-card mt-4">
            <div class="d-grid info-card-title">
              <h3>Historial registro</h3>
              <div class="d-grid card-buttons-1">
                <img src="assets/svg/edit.svg" />
                <button class="btn btn-round-outline-mini">
                  <img class="center-svg" src="assets/svg/arrow-up.svg" />
                </button>
              </div>
            </div>
            <div class="info-card-detail grid-2col mt-2">
              <div class="info-item">
                <span class="label">Creado por:</span>
                <span class="value d-flex align-center gap-8">
                  <img src="assets/svg/user-icon.svg" alt="user" width="20" />
                  {{ tarea?.creadoPor?.nombre }} {{ tarea?.creadoPor?.apellido
                  }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">Fecha:</span>
                <span class="value"
                  >{{ tarea?.fecha_creacion | date: 'dd/MM/yyyy HH:mm' }}</span
                >
              </div>

              <div class="info-item">
                <span class="label">Modificado por:</span>
                <span class="value d-flex align-center gap-8">
                  <img src="assets/svg/user-icon.svg" alt="user" width="20" />
                  {{ tarea?.actualizadoPor?.nombre }} {{
                  tarea?.actualizadoPor?.apellido }}
                </span>
              </div>
              <div class="info-item">
                <span class="label">Fecha:</span>
                <span class="value"
                  >{{ tarea?.fecha_actualizacion | date: 'dd/MM/yyyy HH:mm'
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="detail-container">
    <div class="prospect-card">
      <p>Cargando detalles de tarea...</p>
    </div>
  </div>
</ng-template>